import axios from 'axios';
import session from './session';

axios.interceptors.request.use(cf => {
    cf.headers['Linkage-Event-Token'] = session.getString('token') || '';
    cf.baseURL = process.env.VUE_APP_URL
    return cf;
});
axios.interceptors.response.use(
    response => {
        let data = response.data.data;
        let code = response.status;
        // 401: 没有权限
        // 403：参数错误
        // 500：服务器错误
        // 404：找不到 
        if (code === 200) {
            let res = {
                data,
                code
            }
            return res
        }
    },
    error => {
        let data = error.response.data
        let code = error.response.status;
        let err = {
            data,
            code
        }
        return err
        // if (error.toString().indexOf('timeout') != -1) {
        //     return Promise.reject({
        //         statusCode: 408
        //     });
        // } else {
        //     return Promise.reject({
        //         statusCode: (error.response && error.response.status) || 404,
        //         type: "r",
        //         message: (error && error.toString()) || ''
        //     });
        // }
    }
)
axios.postForm = (url, data, config) => {
    return axios.post(url, {
        ...data
    }, {
        ...config,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

export default axios;